import styled from "styled-components";

const StatePopupBottomLinkBox = styled.a`
    font-size: 14px;
    text-decoration: underline;
    text-align: center;
    margin: 20px 0;
`;

export default StatePopupBottomLinkBox;